export const ITEM_TEMPLATES = Object.freeze({
  smallRedTonic: Object.freeze({
    key: 'smallRedTonic', name: 'Small Red Tonic', kind: 'consumable', stack: 99,
    description: 'Restores 60 health.', heal: 60, cooldownMs: 1500, color: '#c83d32'
  }),
  militiaDao: Object.freeze({
    key: 'militiaDao', name: 'Militia Dao', kind: 'equipment', slot: 'weapon', stack: 1,
    description: 'A dependable frontier blade.', attack: 0, visual: 'militia', color: '#b7a17c'
  }),
  temperedDao: Object.freeze({
    key: 'temperedDao', name: 'Tempered Dao', kind: 'equipment', slot: 'weapon', stack: 1,
    description: 'Heat-darkened steel. Attack +6.', attack: 6, visual: 'tempered', color: '#e0b45c'
  }),
  crimsonDao: Object.freeze({
    key: 'crimsonDao', name: 'Crimson Warden Dao', kind: 'equipment', slot: 'weapon', stack: 1,
    description: 'A scarlet edge taken from the quarry Warden. Attack +12.', attack: 12, visual: 'crimson', color: '#e06b52'
  }),
  wolfhideCoat: Object.freeze({
    key: 'wolfhideCoat', name: 'Wolfhide Coat', kind: 'equipment', slot: 'armor', stack: 1,
    description: 'Layered hide. Defence +4.', defense: 4, visual: 'wolfhide', color: '#9b7452'
  }),
  ashFangCharm: Object.freeze({
    key: 'ashFangCharm', name: 'Ash Fang Charm', kind: 'equipment', slot: 'charm', stack: 1,
    description: 'A warm ward. Maximum health +20.', maxHealth: 20, visual: 'fang', color: '#d76d4b'
  })
});

export const EQUIPMENT_SLOTS = Object.freeze(['weapon', 'armor', 'charm']);
export const INVENTORY_SIZE = 20;
export const QUICKSLOT_SIZE = 8;

export function starterInventory() {
  const slots = Array(INVENTORY_SIZE).fill(null);
  slots[0] = { itemKey: 'smallRedTonic', quantity: 3 };
  return {
    slots,
    equipment: { weapon: 'militiaDao', armor: null, charm: null },
    quickslots: ['smallRedTonic', null, null, null, null, null, null, null]
  };
}

export function effectiveStats(equipment = {}, upgrades = {}) {
  const stats = { attack: 0, defense: 0, maxHealth: 0 };
  for (const [slot, itemKey] of Object.entries(equipment)) {
    const item = ITEM_TEMPLATES[itemKey];
    if (!item) continue;
    stats.attack += item.attack || 0;
    stats.defense += item.defense || 0;
    stats.maxHealth += item.maxHealth || 0;
    const tier = Math.max(0, Math.min(3, Math.trunc(upgrades[slot] || 0)));
    if (tier) {
      stats.attack += tier * (slot === 'weapon' ? 3 : 1);
      stats.defense += tier * (slot === 'armor' ? 2 : 0);
      stats.maxHealth += tier * (slot === 'charm' ? 8 : 0);
    }
  }
  return stats;
}
